
import { AccountEffects } from './account.effects';
import { AuthEffects } from './auth.effects';
import { GameEffects } from './game.effects';
import { SharedEffects } from './shared.effects';
import { TournamentEffects } from './tournament.effects';
export const effects: any[] = [
    AccountEffects,
    AuthEffects,
    TournamentEffects,
    SharedEffects,
    GameEffects
];
